/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Scope_NationalInputs */



/**
* | output |
* | --- |
* | "National" |
*
* @param {Community_Scope_NationalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_scope_national = /** @type {((inputs?: Community_Scope_NationalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Scope_NationalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("National")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nacional")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nacional")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nazionale")
	return /** @type {LocalizedString} */ ("National")
});